import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="mx-auto flex max-w-3xl flex-col items-center px-4 py-24 text-center md:px-6">
      <span className="flex h-20 w-20 items-center justify-center rounded-2xl bg-primary-100 text-4xl text-primary-600">
        <i className="ri-chat-3-line" aria-hidden="true" />
      </span>
      <p className="mt-6 font-heading text-6xl font-black text-primary-500">404</p>
      <h1 className="mt-3 font-heading text-2xl font-black text-foreground-950">这颗瓜，还没长出来</h1>
      <p className="mt-3 max-w-md text-sm leading-6 text-foreground-600">
        你访问的页面不存在或已被挪走。不如回首页，看看今天又有哪些新鲜的校园瓜料。
      </p>
      <div className="mt-7 flex flex-wrap justify-center gap-3">
        <Link to="/" className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600">
          <i className="ri-home-line" aria-hidden="true" /> 回到首页
        </Link>
        <Link to="/about" className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-100 px-6 py-2.5 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-700">
          关于我们
        </Link>
      </div>
    </section>
  );
}